import AboutEntry from './about-entry';

export default class AboutEntryDesktop extends AboutEntry {
	constructor(...args) {
		super(...args);
	}

	_retrieveDOM() {
		super._retrieveDOM();

		this.dom.header = this.dom.page.querySelector('.header');
		this.dom.imgHeader = this.dom.header.querySelector('.container-img');
	}

	resize() {
		super.resize();

		console.log(this.dom.header.offsetHeight);

		this.dom.header.style.minHeight = this.dom.imgHeader.offsetHeight + "px";
	}

	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/about/entry/about-entry.desktop.js